import { render, staticRenderFns } from "./OnlineSessionEdit.vue?vue&type=template&id=610e4f05&scoped=true&"
import script from "./OnlineSessionEdit.vue?vue&type=script&lang=js&"
export * from "./OnlineSessionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e4f05",
  null
  
)

export default component.exports